import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Stockitem } from '../../../../interfaces/stockitem';
import { UserService } from '../../../../services/user';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { ItemsService } from '../../../../services/items.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import Swal from 'sweetalert2';
import { PetServices } from '../../../../services/petservices';

@Component({
  selector: 'app-allservices',
  templateUrl: './allservices.component.html',
  styleUrls: ['./allservices.component.scss']
})
export class AllservicesComponent implements OnInit {
  searchKey: string = '';
  searched: boolean = false;
  pageIndex: number = 1;
  pageSize: number = 10;

  // ==================== Data Properties ====================
  allData: Stockitem[] = [];
  totalItems: number = 0;
  stockTotal: number = 0;

  // ==================== UI State ====================
  contentReady: boolean = true;
  noData: boolean = false;
  isMobile: boolean = false;
  cartPopUp: boolean = false;
  isStockTaking: boolean = false;

  // ==================== Pagination ====================
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  newPage: number = 1;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  // ==================== Cart ====================
  cartItems: any[] = [];
  cartItemCount: number = 0;

  // ==================== Warehouse & Search ====================
  warehouseId: number | null = null;
  allWareHouses: any[] = [];

  // ==================== User & Role Management ====================
  accountType: string = '';
  isAdmin: boolean = false;
  isSubAdmin: boolean = false;
  isSuperAdmin: boolean = false;
  isAr: boolean = localStorage.getItem('language') === 'ar';

  // ==================== Table Configuration ====================
  displayedColumns: string[] = [this.isAr ? 'name_ar' : 'name_en', 'pet_type', 'type', 'pricea'];

  constructor(
    private router: Router,
    private _userService: UserService,
    private _ItemsService: ItemsService,
    private deviceService: DeviceDetectorService,
    private _petServices: PetServices
  ) { }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();
    if (this.isMobile) {
      this.router.navigateByUrl('/Home.moblie');
      return;
    }

    const posId = localStorage.getItem('posId');
    this.warehouseId = posId ? Number(posId) : null;

    this.loadCartForCurrentWarehouse();

    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accountType = data['user_type'];
        this.isAdmin = this.accountType === '1' || this.accountType === '10';
        this.isSuperAdmin = this.accountType === '10';
        this.isSubAdmin = this.accountType === '6';

        if (this.isAdmin || this.isSubAdmin || this.isSuperAdmin) {
          this.displayedColumns = [
            this.isAr ? 'name_ar' : 'name_en',
            'pet_type',
            'type',
            'price',
            'pricea',
            'delete'
          ];
        }

        if (this.warehouseId) {
          this.getServicesByWarehouse(1, this.pageSize);
        } else {
          this.noData = true;
          this.contentReady = false;
        }
      },
      error: (error) => {
        console.error(error);
        this.contentReady = false;
      }
    });

    this._ItemsService.getWearHouses().subscribe({
      next: (res) => {
        this.allWareHouses = res.warehouse || [];
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

  onEnterPressed(): void {
    this.pageIndex = 1;
    this.search();
  }

search(): void {
  const keyword = this.searchKey?.trim();

  this.pageIndex = 1;
  this.newPage = 1;
  this.searched = !!keyword;

  if (this.paginator) {
    this.paginator.pageIndex = 0;
  }

  if (keyword) {
    this.searchServices(1, this.pageSize, keyword);
  } else {
    this.getServicesByWarehouse(1, this.pageSize);
  }
}

  clearSearch(): void {
    this.searchKey = '';
    this.searched = false;
    this.pageIndex = 1;
    this.resetPagination();
    this.getServicesByWarehouse(this.pageIndex, this.pageSize);
  }

  // ==================== Warehouse Management ====================
  applyWareHouse(id: any): void {
    this.warehouseId = Number(id);
    this.searchKey = '';
    this.searched = false;
    this.resetPagination();
    this.getServicesByWarehouse(1, this.pageSize);

    this.clearCart();
  }

resetPagination(): void {
  this.pageIndex = 1;
  this.newPage = 1;

  if (this.paginator) {
    this.paginator.pageIndex = 0;
  }
}

  // ==================== Data Fetching ====================
  getAllStockData(page: number = 1, perPage: number = 10): void {
    this.contentReady = true;

    this._petServices.getAll(page, perPage).subscribe({
      next: (data) => {
        this.allData = data.data || [];
        this.stockTotal = data.total || 0;
        this.totalItems = data.total || 0;
        this.dataSource = new MatTableDataSource<any>(this.allData);
        this.contentReady = false;
        this.noData = this.allData.length === 0;

 
      },
      error: (error) => {
        console.error(error);
        this.allData = [];
        this.dataSource = new MatTableDataSource<any>([]);
        this.totalItems = 0;
        this.noData = true;
        this.contentReady = false;
      }
    });
  }

  getwarehouse(id: any, page: number): void {
    this.warehouseId = Number(id);
    this.pageIndex = page;
    this.getServicesByWarehouse(page, this.pageSize);
  }

getServicesByWarehouse(page: number = 1, perPage: number = 10): void {
  if (!this.warehouseId) {
    this.noData = true;
    this.contentReady = false;
    return;
  }

  this.contentReady = true;

  this._petServices.getByWarehouse(this.warehouseId, page, perPage).subscribe({
    next: (res: any) => {
      this.allData = res.data || [];
      this.dataSource = new MatTableDataSource<any>(this.allData);

      this.totalItems = Number(res.total || 0);
      this.stockTotal = Number(res.total || 0);

      this.pageIndex = Number(res.current_page || page);
      this.newPage = this.pageIndex;

      this.noData = this.totalItems === 0;
      this.contentReady = false;
    },
    error: (err) => {
      console.log(err);
      this.allData = [];
      this.dataSource = new MatTableDataSource<any>([]);
      this.totalItems = 0;
      this.stockTotal = 0;
      this.noData = true;
      this.contentReady = false;
    }
  });
}
searchServices(page: number = 1, perPage: number = 10, search: string): void {
  if (!this.warehouseId) {
    this.noData = true;
    this.contentReady = false;
    return;
  }

  this.contentReady = true;

  this._petServices.searchServices(this.warehouseId, search, page, perPage).subscribe({
    next: (res: any) => {
      this.allData = res.data || [];
      this.dataSource = new MatTableDataSource<any>(this.allData);

      this.totalItems = Number(res.total || 0);
      this.stockTotal = Number(res.total || 0);

      this.pageIndex = Number(res.current_page || page);
      this.newPage = this.pageIndex;

      this.noData = this.totalItems === 0;
      this.contentReady = false;
    },
    error: (err) => {
      console.log(err);
      this.allData = [];
      this.dataSource = new MatTableDataSource<any>([]);
      this.totalItems = 0;
      this.stockTotal = 0;
      this.noData = true;
      this.contentReady = false;
    }
  });
}
  // ==================== Pagination ====================
  onPaginateChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.newPage = this.pageIndex;

    if (this.searched && this.searchKey.trim()) {
      this.searchServices(this.pageIndex, this.pageSize, this.searchKey.trim());
    } else {
      this.getServicesByWarehouse(this.pageIndex, this.pageSize);
    }
  }

  // ==================== Navigation & Actions ====================
  edit(itemobj: any): void {
    this.router.navigate(['/AddService'], { queryParams: itemobj });
  }

  clone(itemobj: any): void {
    this.router.navigate(['/AddService'], {
      queryParams: { ...itemobj, isClone: true }
    });
  }

  deleteitem(id: string): void {
    Swal.fire({
      title: this.isAr ? 'متأكد؟؟' : 'Are You Sure?',
      showCancelButton: true,
      confirmButtonText: this.isAr ? 'اه' : 'YES',
      cancelButtonText: this.isAr ? 'لا' : 'No'
    }).then((result) => {
      if (result.isConfirmed) {
        this.contentReady = true;
        this._petServices.delete(parseInt(id, 10)).subscribe({
          next: () => {
            if (this.searched && this.searchKey.trim()) {
              this.searchServices(this.pageIndex, this.pageSize, this.searchKey.trim());
            } else {
              this.getServicesByWarehouse(this.pageIndex, this.pageSize);
            }
          },
          error: (err) => {
            console.log(err);
            this.contentReady = false;
          }
        });
      }
    });
  }

  // ==================== Cart Management ====================
  addToCart(item: any): void {
    const index = this.cartItems.findIndex(cartItem => cartItem.id === item.id && cartItem.cartItemType === 'service');

    if (index !== -1) {
      this.cartItems.splice(index, 1);
    } else {
      this.cartItems.push({ ...item, cartItemType: 'service' });
    }

    this.saveCart();
  }

  isInCart(item: any): boolean {
    return this.cartItems.some(cartItem => cartItem.id === item.id && (cartItem.cartItemType || 'service') === 'service');
  }

  removeFromCart(item: any): void {
    const itemType = item.cartItemType || 'service';
    const index = this.cartItems.findIndex(cartItem => cartItem.id === item.id && (cartItem.cartItemType || 'service') === itemType);

    if (index !== -1) {
      this.cartItems.splice(index, 1);
      this.saveCart();
    }

    this.cartItemCount = this.cartItems.length;

    if (this.cartItems.length === 0) {
      this.cartPopUp = false;
      this.clearCart();
    }
  }

  quickOrder(): void {
    this.router.navigate(['/Addorderstore'], {
      queryParams: {
        cart: JSON.stringify(this.cartItems),
        warehouseIdFromCart: this.warehouseId
      }
    });
  }

  close(): void {
    this.cartPopUp = false;
  }

  cartPopUpOpen(): void {
    this.cartPopUp = true;
  }

  // ==================== Helpers ====================
  private loadCartForCurrentWarehouse(): void {
    const currentWarehouseId = this.getCurrentWarehouseId();
    const cartWarehouseId = localStorage.getItem('cartWarehouseId');

    if (cartWarehouseId && currentWarehouseId && cartWarehouseId !== currentWarehouseId) {
      this.clearCart();
      return;
    }

    const storedCart = localStorage.getItem('cart');

    try {
      this.cartItems = storedCart ? JSON.parse(storedCart) : [];
    } catch {
      this.cartItems = [];
      this.clearCart();
    }

    this.cartItemCount = this.cartItems.length;
  }

  private saveCart(): void {
    this.cartItemCount = this.cartItems.length;

    if (!this.cartItems.length) {
      this.clearCart();
      return;
    }

    const currentWarehouseId = this.getCurrentWarehouseId();
    this.cartItems = this.cartItems.map(item => ({
      ...item,
      cartItemType: item.cartItemType || (item.quantity !== undefined ? 'product' : 'service')
    }));
    localStorage.setItem('cart', JSON.stringify(this.cartItems));

    if (currentWarehouseId) {
      localStorage.setItem('cartWarehouseId', currentWarehouseId);
    }
  }

  private clearCart(): void {
    this.cartItems = [];
    this.cartItemCount = 0;
    localStorage.removeItem('cart');
    localStorage.removeItem('cartWarehouseId');
  }

  private getCurrentWarehouseId(): string | null {
    return this.warehouseId ? String(this.warehouseId) : localStorage.getItem('posId');
  }

  fixImage(url: any): string {
    return `https://backendproduction.blueboxpet.com/storage/app/public/${url}`;
  }
}
